import React from 'react';
//import { Spinner } from 'react-bootstrap';

export default function LoadingComponent() {
  return ( <h1>Loading ...</h1>
  );
}
